module.exports = __webpack_public_path__ + "media/images/checkout/challenger/mail-7458033550e5046075f5cdef475749a4.svg";